import type { FunctionComponent } from "react"

import { TeamsWrapper } from "@/modules/companies/client/components/TeamsWrapper/TeamsWrapper"

export const Teams: FunctionComponent = () => (
  <div data-testid="company_teams">
    <TeamsWrapper />
  </div>
)
